module.exports = __webpack_public_path__ + "static/media/shadow.4725c01a.png";